export default __webpack_public_path__ + "static/media/icon_instagram.516a51e4.svg";